type PendingMediaItem = {
  id: string;
  pending: true;
  type: string;
  path: string | null;
  url_youtube: string | null;
  priority: number;
};

let pendingTempSeq = 0;
let pendingMedia: PendingMediaItem[] = [];
const listeners = new Set<() => void>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const pendingProductMediaStore = {
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getAll() {
    return pendingMedia;
  },
  add(item: {
    type: string;
    path?: string | null;
    url_youtube?: string | null;
    priority?: number;
  }) {
    const entry: PendingMediaItem = {
      id: `pending-${Date.now()}-${++pendingTempSeq}`,
      pending: true,
      type: item.type,
      path: item.path || null,
      url_youtube: item.url_youtube || null,
      priority: item.priority ?? pendingMedia.length,
    };
    pendingMedia = [...pendingMedia, entry];
    emit();
    return entry;
  },
  remove(id: string) {
    pendingMedia = pendingMedia.filter((item) => item.id !== id);
    emit();
  },
  updatePriority(id: string, priority: number) {
    pendingMedia = pendingMedia.map((item) =>
      item.id === id ? { ...item, priority } : item
    );
    emit();
  },
  clear() {
    pendingMedia = [];
    emit();
  },
};
